import React, { useRef } from "react";

import Camera from "./BrowserCamera";
import { getCompressedImageWithThumbnail } from "./helper";

const TakePhoto = ({ onSuccess, onError, overlay }) => {
    const videoSettings = useRef();

    const handleCameraStart = (videoStream) => {
        if (videoStream.getTracks()[0].getSettings)
            videoSettings.current = videoStream.getTracks()[0].getSettings();
    };

    const handleCameraError = (error) => onError(error);

    const capturePicture = async (dataUri) => {
        const { width, height } = videoSettings.current;
        const newHeight = height / (width / window.innerWidth);

        const img = await getCompressedImageWithThumbnail(dataUri);

        onSuccess({
            imageType: 1,
            imageUrl: img.imageUrl,
            thumbnailUrl: img.thumbnailUrl,
            width: width,
            height: newHeight ? newHeight : 0,
        });
    };

    return (
        <Camera
            overlay={overlay}
            isSilentMode={true}
            idealResolution={{ width: 1024, height: 1024 }}
            isDisplayStartCameraError={false}
            onTakePhoto={(dataUri) => {
                capturePicture(dataUri);
            }}
            onCameraStart={(stream) => {
                handleCameraStart(stream);
            }}
            onCameraError={(error) => {
                handleCameraError(error);
            }}
        />
    );
};

export default TakePhoto;
